// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Toasted from 'vue-toasted';
import VueScrollTo from 'vue-scrollto';
import $ from 'jquery';
import store from './store';
import VeeValidate from 'vee-validate';
import messagesPl from './vee-validate-pl.js';


Object.defineProperty(Vue.prototype, '$', { value: $ });

Vue.config.productionTip = false;
const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'pl',
  dictionary: {
    pl: {
      messages: messagesPl,
    },
  },
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty', // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'validations', // the nested key under which the validation messsages will be located
};
Vue.use(VueAxios, axios);
Vue.use(Vuetify);
Vue.use(Toasted);

Vue.toasted.register('register_success', 'Dziękujemy za rejestrację placówki. Proszę sprawdzić email.', {
  type: 'success',
  theme: 'bubble',
  position: 'top-right',
  duration: 10000,
});

Vue.toasted.register('form_success', 'Dziękujemy za wiadomość.', {
  type: 'success',
  theme: 'bubble',
  position: 'top-right',
  duration: 10000,
});

const fixIdScrolling = {
  watch: {
    $route(to, from) {
      const currentRoute = this.$router.currentRoute;
      const idToScrollTo = currentRoute.hash;
      this.$nextTick(() => {
        if (idToScrollTo && document.querySelector(idToScrollTo)) {
          document.querySelector(idToScrollTo).scrollIntoView(
            {
              behavior: 'smooth',
              block: 'start'
            }
          );
        }
      });
    },
  },
};
Vue.use(VeeValidate, config);
/* eslint-disable no-new */
new Vue({
  // mixins: [fixIdScrolling],
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
});



// WEBPACK FOOTER //
// ./src/main.js